import { Typography, Button } from "@mui/material";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import CustomHighlight from "../custom-highlight";
import { handleTrackReportClick } from "../../../utils/google-analytics";
import "./global-search.scss";

function GlobalSearchItem({ hit, handleClick }) {
  return (
    <Button
      className="hit-item"
      component={Link}
      to={hit.url}
      target="_blank"
      onClick={() => {
        if (hit.index === "Report Document") {
          handleTrackReportClick({
            event: "report_download_global_search_popup",
            reportId: hit.objectID,
            reportName: hit.title,
            reportDivision: (hit.tags?.[0]?.replace(/^Division: /, '') || ""),
            origin: "Global Search Popup"
          });
        }
        handleClick();
      }}
    >
      <span style={{ fontSize: "large", lineHeight: 1.3 }}>
        <CustomHighlight attribute="title" hit={hit} />
      </span>

      <Typography className="hit-description mt-1" variant="subtitle2" color="textSecondary">
        <CustomHighlight attribute="chunk" hit={hit} />
      </Typography>
    </Button>
  );
}

GlobalSearchItem.propTypes = {
  hit: PropTypes.object.isRequired,
  handleClick: PropTypes.func
};

export default GlobalSearchItem;
